export default function hasTextSelected(target) {
  if (document.selection && document.selection.createRange) {
    if (document.selection.createRange().text) {
      return true;
    }
  }
  return (target.selectionStart != null) && target.selectionStart !== target.selectionEnd;
}
